import { actions } from "./kredittvurderingActions.js";

const initialState = {
    kisIntegration: '',
    debtorList: [],
    filteredList: [],
    searchHistoryData: [],
    fetchedData: [],
    companyRatingData: '',
    personRatingData: '',
    filterString: '',
    hasBislab: false,
    hasKredittvurdering: false,
    termsBase64: '',
    fetched: false,
    loading: false,
    fetchingRating: false,
    error: '',
    ratingError: '',
}

export default function kredittvurderingReducer(state = initialState, action) {

    switch (action.type) {

        case actions.CREDIT_RATING_LOADING:
            return {
                ...state,
                filteredList: [],
                fetched: false,
                loading: true,
                error: null,
                ratingError: null
            };

        case actions.CREDIT_RATING_CLEAR_LOADING:
            return {
                ...state,
                fetched: false,
                loading: false,
                error: null,
                ratingError: null
            }

        case actions.OVERLAY_RATING_LOADING:
            return {
                ...state,
                fetchingRating: true,
                error: null,
                ratingError: null
            };

        case actions.OVERLAY_RATING_CLEAR_LOADING:
            return {
                ...state,
                fetchingRating: false,
                error: null,
                ratingError: null
            };

        case actions.CREDIT_RATING_SET_SOKEVERDI:
            let _filteredList = [];
            if (!action.payload.value) {
                _filteredList = [...state.searchHistoryData[0]?.bislabTransactionsCollection || []]
            }
            else {                  
                const searchTerm = action.payload.value.toUpperCase();
                _filteredList = (state.searchHistoryData[0].bislabTransactionsCollection || []).filter(item =>
                    item.searchIndex.toUpperCase().includes(searchTerm)
                );
            }
   
            return {
                ...state,
                filterString: action.payload.value,
                filteredList: _filteredList
            }

        case actions.COMPANY_RATING_FETCHED:
            return {
                ...state,
                filterString: '',
                companyRatingData: action.payload.ratingData,
                fetched: true,
                loading: false,
                error: null,
                ratingError: null
            };

        case actions.PERSON_RATING_FETCHED:
            return {
                ...state,
                filterString: '',
                personRatingData: action.payload.ratingData,
                fetched: true,
                loading: false,
                error: null,
                ratingError: null
            };
        case actions.RATING_INFO_FETCHED:
            return {
                ...state,
                filterString: '',
                searchHistoryData: [...action.payload.searchHistoryData],
                filteredList: [...action.payload.searchHistoryData[0]?.bislabTransactionsCollection || []],
                fetchedData: [...action.payload.searchHistoryData],
                hasBislab: true,
                hasKredittvurdering: true,
                fetched: true,
                loading: false,
                error: null,
                ratingError: null
            };
        
        case actions.CREDIT_RATING_TERMS_FETCHED:
            console.log(action)
            return {
                ...state,
                termsBase64: `data:application/pdf;base64,${action.payload.fetchedData}`,
                fetched: true,
                loading: false,
                error: null,
                ratingError: null
            };

        case actions.TERMS_ACCEPTED_SUCCESSFULLY:
            return {
                ...state,
                loading: false,
                fetched: true,
                hasBislab: true,
                hasKredittvurdering: true,
            }

        case actions.CREDIT_RATING_DATA_CLEAR:
            return {
                ...state,
                kisIntegration: '',
                debtorList: [],
                filteredList: [],
                searchHistoryData: [],
                fetchedData: [],
                companyRatingData: '',
                personRatingData: '',
                hasBislab: false,
                hasKredittvurdering: false,
                termsBase64: '',
                fetched: true,
                loading: false,
                error: null,
                ratingError: null
            }

        case actions.CREDIT_RATING_DATA_CLEAR_RATING:
            return {
                ...state,
                kisIntegration: '',
                companyRatingData: '',
                personRatingData: '',
                fetched: true,
                loading: false,
                error: null,
                ratingError: null
            };

        case actions.CREDIT_RATING_ERROR:
            return {
                ...state,
                loading: false,
                fetched: true,
                error: action.data.error
            }

        case actions.RATING_ERROR:
            return {
                ...state,
                loading: false,
                fetched: true,        
                ratingError: action.data.error
            }

        default:
            return state;
    }
}
